import React from "react";

import { TypeFiesta } from "@at/design-system-foundation";
import { getMinutesAndHours } from "@at/formatter-utils/lib/time-utils/time.utils";

import * as Styled from "./charging.styles";
import FullChargeInfoModal from "./modals/full-charge-info.modal";
import { FPADataQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_chargingData_ChargingData_chargers_Charger } from "../../../connected-components/hoc/query/__generated__/fpa-page-data.query";

interface TypeOfChargeProps {
  charger: FPADataQuery_search_Search_advert_Advert_specification_Specification_techData_TechData_chargingData_ChargingData_chargers_Charger | null;
}

export const FullCharge = (props: TypeOfChargeProps) => {
  const charger = props.charger;
  const endBatteryPercentage = charger?.fullCharge?.endBatteryPercentage;
  const fullDuration = charger?.fullCharge?.duration || 0;
  return (
    <Styled.ChargingElement>
      <Styled.ChargingSubHeader>
        <TypeFiesta as="span" weight="500">
          Full charge
        </TypeFiesta>
      </Styled.ChargingSubHeader>
      <Styled.ChargingTextInfo>
        <span>up to {endBatteryPercentage}%</span>
        {endBatteryPercentage === 80 && <FullChargeInfoModal />}
      </Styled.ChargingTextInfo>

      <Styled.ChargingSubHeader>
        <TypeFiesta as="span" weight="500" data-gui="full-charge-duration">
          {getMinutesAndHours(fullDuration)}
        </TypeFiesta>
      </Styled.ChargingSubHeader>
    </Styled.ChargingElement>
  );
};

export const TopUpCharge = (props: TypeOfChargeProps) => {
  const charger = props.charger;
  const topUpDurationInHours = charger?.topUp?.duration ?? 0;

  return (
    <Styled.ChargingElement>
      <Styled.ChargingSubHeader>
        <TypeFiesta as="span" weight="500">
          Top up charge
        </TypeFiesta>
      </Styled.ChargingSubHeader>
      <Styled.ChargingText>up to 30 miles</Styled.ChargingText>
      <Styled.ChargingSubHeader>
        <TypeFiesta as="span" weight="500" data-gui="topup-charge-duration">
          {getMinutesAndHours(topUpDurationInHours * 60)}
        </TypeFiesta>
      </Styled.ChargingSubHeader>
    </Styled.ChargingElement>
  );
};
